// TODO convert the stores urls in the same manner as the ones used on orders ( will need some changes on the sidebar and router)
export enum MazeedRoutes {
  stores = "/mazeed/stores",
  storesList = "/mazeed/stores/list",
  createStore = "create",
  storeDetails = "details/:id",
  ordersBase = "/mazeed/orders",
  ordersList = "/mazeed/orders/list",
  orderDetails = "/mazeed/orders/details/:id",
  orderDetailsNew = "/mazeed/orders/:id",
  orderInvoice = "/mazeed/orders/invoice/:id",
  banners = "/mazeed/mazeed_banners",
  bannersList = "/mazeed/mazeed_banners/list",
  bannerCreate = "/mazeed/mazeed_banners/create",
  bannersDetails = "/mazeed/mazeed_banners/details/:id",
  bannersEdit = "/mazeed/mazeed_banners/edit/:id",
  discover = "/mazeed/mazeed_discover",
  discoverCollectionListing = "/mazeed/mazeed_discover/collection_list",
  discoverSectionListing = "/mazeed/mazeed_discover/section_list",
  discoverItems = "items/:tabname?/:id?",
  couponsBase = "/mazeed/mazeed_coupons",
  couponsList = "/mazeed/mazeed_coupons/list",
  couponsCreate = "/mazeed/mazeed_coupons/create",
  couponsDetails = "/mazeed/mazeed_coupons/details/:id",
  productsBase = "/mazeed/mazeed_products",
  productsList = "/mazeed/mazeed_products/list",
  productDetails = "/mazeed/mazeed_products/details/:id",
  categoriesBase = "/mazeed/categories",
  categoriesList = "/mazeed/categories/list",
  categoriesCreate = "/mazeed/categories/create",
  categoriesDetails = "/mazeed/categories/details/:id",
  settlementsBase = "/mazeed/settlements",
  settlementsList = "/mazeed/settlementss/list",
  settlementDetails = "/mazeed/settlements/details/:id",
  settlementInvoice = "/mazeed/settlements/invoice",
  customersBase = "/mazeed/customer",
  customersList = "/mazeed/customer/list",
  customersDetails = "/mazeed/customer/details/:id",
  tagsBase = "/mazeed/tags",
  tagsList = "/mazeed/mazeed_tags/list",
  tagsCreate = "/mazeed/mazeed_tags/create",
}
